import scholarship from '@/api/scholarship'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  main_programs: [],
  sub_programs: [],
  grading: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_MAIN_PROGRAMS(state, data) {
    state.main_programs = data
  },
  SET_SUB_PROGRAMS(state, data) {
    state.sub_programs = data
  },
  SET_GRADING(state, data) {
    state.grading = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return scholarship.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return scholarship.store(data)
  },

  update(context, data) {
    return scholarship.update(data)
  },
  destroy(context, params) {
    return scholarship.destroy(params.acps_id, params.grade_definition_id)
  },

  async find(context, params) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await scholarship.find(
        params.acps_id,
        params.grade_definition_id
      )
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async getSubProgram(context, acpId) {
    let response = await scholarship.getSubProgram(acpId)
    context.commit('SET_SUB_PROGRAMS', response)
    return response
  },

  async getGrading(context, acpId) {
    let response = await scholarship.getGrading(acpId)
    context.commit('SET_GRADING', response)
    return response
  },

  async dataBeforeCreate(context) {
    if (!context.state.main_programs.length > 0) {
      let response = await scholarship.getMainProgram()
      context.commit('SET_MAIN_PROGRAMS', response)
    }
  }
}
